import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Image } from "hesus-ui-kit";
import errorIcon from "@icons/ic-error.svg";

import {
  ErrorDiv,
  ErrorWrapper,
  ErrorText,
  ErrorPara,
} from "./ErrorBox.styled";

const ErrorBox = (props) => {
  const { t, errors } = props;

  return (
    <ErrorDiv>
      <ErrorWrapper>
        <Image
          src={errorIcon}
          styles={{ float: "left", margin: "0 0.625rem 0 0", width: "1.25rem" }}
        />
        <ErrorPara>
          {errors?.length > 0 &&
            errors.map((error) => {
              return <ErrorText>{t(error)}</ErrorText>;
            })}
        </ErrorPara>
      </ErrorWrapper>
    </ErrorDiv>
  );
};

ErrorBox.propTypes = {};

ErrorBox.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorBox);
